import * as S from './ErrorPage.style';

export type ErrorPageProps = Readonly<
  React.PropsWithChildren<{
    illustration: React.ReactNode;
    title: string;
    subtitle: string;
  }>
>;

export function ErrorPage({
  illustration,
  title,
  subtitle,
  children,
}: ErrorPageProps) {
  return (
    <S.PositionContentDiv>
      <S.Main>
        <S.Illustration>{illustration}</S.Illustration>

        <S.Article>
          <S.Title variant="h4" component="h1" isDisplay weight="medium">
            {title}
          </S.Title>

          <S.SubTitle variant="body1" component="p" isDisplay>
            {subtitle}
          </S.SubTitle>

          {children}
        </S.Article>
      </S.Main>
    </S.PositionContentDiv>
  );
}
